import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13;

import { css, memoizeStyle } from "../../../lib/theming/Emotion";
export var styles = memoizeStyle({
  root: function root(t) {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      background: ", ";\n      border-radius: ", ";\n      box-sizing: ", ";\n      outline: none;\n      padding: ", " ", ";\n      margin: ", " 0;\n    "])), t.menuBgDefault, t.menuBorderRadius, t.menuBoxSizing, t.menuPaddingY, t.menuPaddingX, t.menuOffsetY);
  },
  mobileRoot: function mobileRoot(t) {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      border-radius: 0;\n      margin: 0;\n      padding: 0 ", ";\n    "])), t.mobileMenuPaddingX);
  },
  alignRight: function alignRight() {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      flex: 1 1 100%;\n    "])));
  },
  alignRightIE11: function alignRightIE11() {
    return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n      float: right;\n      width: 100%;\n    "])));
  },
  alignRightIE11FixAutoWidth: function alignRightIE11FixAutoWidth() {
    return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n      box-sizing: border-box !important; // override root styles\n      overflow: hidden !important; // override root styles\n    "])));
  },
  scrollContainer: function scrollContainer(t) {
    return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n      padding: ", " 0;\n    "])), t.menuScrollContainerContentWrapperPaddingY);
  },
  scrollContainerMobile: function scrollContainerMobile(t) {
    return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n      padding: ", " 0;\n    "])), t.mobileMenuScrollContainerContentWrapperPaddingY);
  },
  shadow: function shadow(t) {
    return css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteralLoose(["\n      border: ", ";\n      box-shadow: ", ";\n    "])), t.menuBorder, t.menuShadow);
  },
  wrapper: function wrapper() {
    return css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteralLoose(["\n      position: relative;\n      z-index: 1;\n      width: 100%;\n      overflow: hidden;\n      line-height: 18px;\n      box-sizing: border-box;\n    "])));
  },
  headerWrapper: function headerWrapper() {
    return css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteralLoose(["\n      top: -5px;\n    "])));
  },
  footerWrapper: function footerWrapper() {
    return css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteralLoose(["\n      bottom: -5px;\n    "])));
  },
  contentWrapper: function contentWrapper() {
    return css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteralLoose(["\n      padding: 6px 18px 7px 8px;\n    "])));
  },
  menuSeparatorWrapper: function menuSeparatorWrapper(t) {
    return css(_templateObject13 || (_templateObject13 = _taggedTemplateLiteralLoose(["\n      height: ", ";\n    "])), t.menuSeparatorBorderWidth);
  }
});